import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 60vh;
  margin-bottom: 70px;

  .dataGrid {
    text-align: center !important;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .header button {
    width: auto;
  }

  .MuiDataGrid-root {
    width: 100%;
    height: 100%;
  }

  .MuiDataGrid-columnHeader {
    background: #020c90;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    text-align: center !important;
    padding: 10px 0;
    border-bottom: 1px solid #ccc;

    .MuiSvgIcon-root {
      color: #fff;
      opacity: 1 !important;
    }
  }

  .css-1rtnrqa {
    display: none;
  }

  .css-68pk0f {
    width: 40%;

    @media all and (max-width: 768px) {
      width: 100%;
    }
  }

  .css-1knaqv7-MuiButtonBase-root-MuiButton-root {
    display: none;
  }

  .css-3be3ve-MuiFormControl-root-MuiTextField-root-MuiDataGrid-toolbarQuickFilter {
    width: 40%;

    @media all and (max-width: 768px) {
      width: 100%;
    }
  }

  .createdDate {
    display: flex;
    flex-direction: column;
  }

  .MuiDataGrid-virtualScrollerRenderZone {
    text-align: center;
  }

  .button-icon {
    background: none;
    border: none;
    cursor: pointer;
    margin: 0 5px;

    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
      &:hover {
        filter: none;
      }
    }

    img {
      width: 20px;

      &:hover {
        filter: brightness(0) saturate(100%) invert(16%) sepia(41%) saturate(7143%) hue-rotate(237deg) brightness(63%)
          contrast(126%);
      }
    }
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 8px;
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #9a9a9a;
    height: 5px;
    border-radius: 10px;
  }
`;
